import { Component } from '@angular/core';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Store } from '@ngxs/store';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';
import { OpenChat } from 'src/app/store/samwin/chats/chats.actions';
import { ChatsSelectors } from 'src/app/store/samwin/chats/chats.selectors';
import { ChatDetails } from 'src/app/store/samwin/chats/models/chat-details';
import { flyInOut } from '../../utility/animation/animations';

@Component({
   selector: 'samweb-chat-toast',
   templateUrl: './chat-toast.component.html',
   styleUrls: ['./chat-toast.component.scss'],
   animations: [flyInOut],
})
export class ChatToastComponent extends Toast {
   @SelectSnapshot(ChatsSelectors.getRingingChat)
   public ringingChat: ChatDetails;

   public openMessageIcon = WellKnownIconsEnum.OPEN_CHAT.icon;

   constructor(protected toastrService: ToastrService, public toastPackage: ToastPackage, public store: Store) {
      super(toastrService, toastPackage);
   }

   openChat() {
      this.store.dispatch(new OpenChat(this.ringingChat.id));
   }
}
